import { Button, Grid, Typography } from "@mui/material";
import { DateRangePickerComponent, DateRangePickerComponentProps } from "../../components/DateRangePickerComp";
import { MainContainer } from "../../components/MainContainerComp";
import { buttonContainerStyle, buttonStyle, subHeaderStyle, descriptionStyle } from "./styled";

interface IDispatchHistoryProps {
  dateRangePickerComponentProps: DateRangePickerComponentProps,
  handleView: () => void;
  disabledView: boolean
}

export const DispatchHistory: React.FC<IDispatchHistoryProps> = ({
  dateRangePickerComponentProps,
  handleView,
  disabledView
}) => {
  return (
    <MainContainer>
      <Typography sx={descriptionStyle} data-automation="description-text">
        Enter Start and End Dates and tap [View] to generate your dispatch history report
      </Typography>
      <Typography sx={subHeaderStyle} className='sub-title' data-automation="dispatch-history-date-range">Dispatch History Date Range</Typography>
      <DateRangePickerComponent {...dateRangePickerComponentProps} />
      <Grid sx={{ justifyContent: 'center' }} container>
        <Grid sx={buttonContainerStyle} item xs={12} md={8}>
          <Button sx={buttonStyle} onClick={handleView} disabled={disabledView} variant="contained" size="medium" data-automation="view-btn">
            View
          </Button>
        </Grid>
      </Grid>
    </MainContainer>
  )
}